import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PASSWORD_RULES } from '../services/password/rules/password-rules';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || value.trim() === '') {
      return { required: true };
    }

    const errors: ValidationErrors = {};
    for (const rule of PASSWORD_RULES) {
      if (!rule.test(value)) {
        errors[rule.key] = true;
      }
    }

    return Object.keys(errors).length ? errors : null;
  };
}
